import io from 'socket.io-client';
import jwt from 'jsonwebtoken';

import storage from './storage';
import { KEY_LOCAL_STORAGE } from './../const';

let socket;
let connected = false;

let observers = [];

/**
 * Realiza a conexão com o WebSocket
 * @param {string} room identificado da sala
 */
const connectWebSocket = room => {
  if (!room) {
    return;
  }
  socket = io(process.env.VUE_APP_SERVER_SOCKET);

  socket.on('connect', () => {
    socket.emit('join_room', room);
  });

  socket.on('join_room_response', () => {
    connected = true;
  });

  socket.on('message', data => {
    publish(data);
  });

  socket.on('connect_error', err => {
    console.error(err);
  });
};

/**
 * Recupera o UserToken
 */
const getUserToken = () => {
  return storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
};

/**
 * Recupera a nome da sala com base no email do usuário
 * @param {string} userToekn user token do usuário
 */
const getUserRoom = userToekn => {
  const decoded = jwt.decode(userToekn);

  if (decoded.email) {
    return btoa(decoded.email);
  }

  return null;
};

/**
 * Adiciona observable ao storage
 * para a key 'user-token'
 */
storage.subscribe(key => {
  if (key === KEY_LOCAL_STORAGE.USER_TOKEN) {
    main();
  }
});

/**
 * Conecta/desconecta conforme o usuário logado ou não
 */
const main = () => {
  const userToken = getUserToken();

  if (userToken) {
    const room = getUserRoom(userToken);
    connectWebSocket(room);
  } else {
    if (connected && socket) {
      socket.disconnect();
    }
  }
};

const publish = data => {
  observers.forEach(element => {
    element.observer(data);
  });
};

export default {
  subscribe(observer) {
    const id = crypto.randomUUID();
    observers.push({ id, observer });
    return id;
  },
  unsubscribe(observer) {
    observers = observers.filter(obs => obs.id !== observer);
  },
};

main();
